import gsap from "gsap";

export default class ZoomWidget {
  constructor (container) {
    this.input = container.querySelector("input[type='range']");
    this.increase = container.querySelector("#plus");
    this.decrease = container.querySelector("#minus");
    this.images = container.querySelectorAll(".zoom-images > img");
    this.tl = gsap.timeline({ paused: true });

    this.setTimeline();

    this.input.addEventListener("input", (event) => {
      this.updateZoom(event.target.value);
    });

    this.increase.addEventListener("click", () => {
      if (this.tl.progress() < 1) {
        const progress = this.tl.progress() + 0.05;
        this.tl.progress(progress);
        this.input.value = progress;
      };
    })

    this.decrease.addEventListener("click", () => {
      if (this.tl.progress() > 0) {
        const progress = this.tl.progress() - 0.05;
        this.tl.progress(progress)
        this.input.value = progress;
      };
    })
  }

  setTimeline() {
    let index = 1;
    const total = this.images.length - 1;

    while (index <= total) {
      this.tl.add(
        gsap.from(this.images[index], { autoAlpha: 0, ease: "none" })
      );

      ++index;
    }

    const duration = this.tl.duration();

    this.tl.add(
      gsap.to(
        ".zoom-slider > svg > circle",
        {
          duration,
          x: 420,
          ease: "none"
        }
      ),
      0
    );
  }

  updateZoom (progress) {
    this.tl.progress(progress);
  }
}